"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameDate = exports.getFormattedDate = void 0;
var getFormattedDate = function (date) {
    var newDate = new Date(date);
    return newDate.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};
exports.getFormattedDate = getFormattedDate;
var isSameDate = function (dateA, dateB) {
    dateA.setHours(0, 0, 0, 0);
    dateB.setHours(0, 0, 0, 0);
    return dateA.getTime() == dateB.getTime();
};
exports.isSameDate = isSameDate;
